// extracted by mini-css-extract-plugin
module.exports = {"companionSection":"companion_companionSection__pTBha","companionContainer":"companion_companionContainer__IsB_v","companionContent":"companion_companionContent__M4_JK"};